import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function SingleItem(props) {
  const { name, msg, date } = props;

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name) {
    const pieces = name.split(' ')
    const first = pieces[0][0];
    let second = name.length > 1 ? pieces[0][1] : "";
    if(pieces.length > 1) {
      second = pieces[1][0]
    }
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${first}${second}`,
    };
  }

  return (
    <React.Fragment>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar {...stringAvatar(name)} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                <i>{name}</i>
              </Typography>
              &nbsp;::&nbsp;
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {date}
              </Typography>
            </React.Fragment>
          }
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body1"
                color="text.primary"
              >
                {msg}
              </Typography>
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </React.Fragment>
  )
}


function Messaggi() {

  let url = "/getmsg.php"
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    url = "http://localhost:8000/getmsg.php"
  }

  const [messagges, setMessages] = React.useState([]);
  React.useEffect(() => {
    fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setMessages(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [url]);


  const items = [];
  for (let i = 0; i < messagges.length; i++) {
    const m = messagges[i];
    items.push(<SingleItem key={i} name={m['nome']} msg={m['messaggio']} date={m['created_at']} />);
  }
  if (messagges.length === 0) {
    items.push(<Typography key="missing">
      Nessun messaggio ancora <br />
      <Button variant="outlined" color="error" onClick={() => {
        window.location.href = '/lista';
      }}>
        be the first one to post something 🤗
      </Button>
    </Typography>)
  }

  return (
    <Container maxWidth="xl" sx={{ pt: "1em" }}>
      <Box sx={{ width: '100%' }}>
        <Stack spacing={0}>
          <Item>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
              {items}
            </List>
          </Item>
        </Stack>
      </Box>
    </Container>
  )
}

export default Messaggi;